export default "__VITE_ASSET__BB4DQWS5__"